import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';
import { NoteForm } from '../generic-notes/NoteForm';
import { CaremapNotesModelFactory } from '../model/CaremapNotesModelFactory';
import { ICaremapNote } from '../model/NotesClient';
import { NewNoteFormViewModel } from './NewNoteFormViewModel';

interface IActiveCaremapNoteCreatorProps {
    noteVM: NewNoteFormViewModel;
    hasPrivateCheckbox?: boolean;
}

export const ActiveCaremapNoteCreator: React.FC<IActiveCaremapNoteCreatorProps> = ({ noteVM, hasPrivateCheckbox = true }) => {
    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const notesFactory = useInstance(CaremapNotesModelFactory);
    useSubscription(() => notesFactory);

    return (
        <NoteForm
            note={noteVM.getNote()}
            isAdd={true}
            canEdit={true}
            noteTarget={noteVM.getNote().otherAttributes.noteTarget}
            hasTitle
            hasPrivateCheckbox={hasPrivateCheckbox}

            // cannot delete while creating
            canDelete={false}

            addAttachmentRequiresInnerhivePlus={noteVM.addAttachmentRequiresInnerhivePlus}
            noteChanged={updatedNote => {
                noteVM.setNote(updatedNote as ICaremapNote);
            }}
        />
    );
};
